import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import Footer from './components/Footer';
import Header from './components/Header';
import ScrollToTop from './components/ScrollToTop';
import content from './data/content';
import Home from './pages/Home';
import NotFound from './pages/NotFound';
import Projects from './pages/Projects';
import './App.css';

function Layout() {
  const location = useLocation();

  return (
    <div className="app">
      <a className="skip-link" href="#main">
        {content.app.skipLink}
      </a>

      <Header />

      {/* Смена ключа по пути перезапускает анимацию входа страницы. */}
      <main className="app__main" id="main" tabIndex={-1} key={location.pathname}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>

      <Footer />

      <ScrollToTop />
    </div>
  );
}

function App() {
  return (
    <Router>
      <Layout />
    </Router>
  );
}

export default App;
